import React from 'react';
import PropTypes from "prop-types";
import LazyLoadImageComponent from "common/components/LazyLoadImage";
const EmptyCartItem = ({ data, width }) => {
  const {
    image: {
      alt: imageAlt,
      title: imageTitle,
      uri: imageUrl,
    },
    title,
    url,
  } = data;
  return (
    <a href={url} className="empty-cart-item" style={{
      width: width
    }}>
      <div className="empty-cart-item__image">
        <LazyLoadImageComponent
          src={imageUrl} alt={imageAlt} title={imageTitle}
        />
      </div>
      <div className="empty-cart-item__title">
        {title}
      </div>
    </a>
  );
};

EmptyCartItem.propTypes = {
  data: PropTypes.shape({
    image: PropTypes.shape({
      alt: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
    }).isRequired,
    title: PropTypes.string.isRequired,
    uri: PropTypes.string.isRequired
  }).isRequired,
};

export default EmptyCartItem;
